import React from "react";

function Planner() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0H24V24H0z"></path>
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"></path>
      <path d="M7 12H9V17H7z"></path>
      <path d="M15 7H17V17H15z"></path>
      <path d="M11 14H13V17H11z"></path>
      <path d="M11 10H13V12H11z"></path>
    </svg>
  );
}

export default Planner;
